export default __webpack_public_path__ + "static/media/dial_needs_work.9659a44e.svg";